import { isAxiosError } from 'axios';
// eslint-disable-next-line import/no-cycle
import { axiosAuth } from '@/axios';
import { User } from '@/types/auth';
import { Endpoints } from '@/enums';

export const refreshJWT = async ({
  refreshToken,
  accessToken,
}: User): Promise<User> => {
  try {
    const res = await axiosAuth.post<User>(Endpoints.Refresh, {
      refreshToken,
      accessToken,
    });
    return res.data;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
